"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAriaLabels = exports.generateRangeOverlayMarks = exports.default = exports.clearRangeOverlayMarks = exports.StepMarkerDrawFunction = void 0;

const getCChild = (DOMElement, className) => DOMElement.querySelector(`.${className}`);

const clearRangeOverlayMarks = function (sliderDOM) {
  let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!sliderDOM) return;
  const sliderBaseDOM = getCChild(sliderDOM.current, `${prefix}slider-base`);

  if (sliderBaseDOM && sliderBaseDOM.children) {
    const lightSliderPipDOM = getCChild(sliderBaseDOM, `${prefix}slider-pips-light`);
    if (lightSliderPipDOM) lightSliderPipDOM.parentNode.removeChild(lightSliderPipDOM);
  }
};

exports.clearRangeOverlayMarks = clearRangeOverlayMarks;

const generateRangeOverlayMarks = function (sliderDOM, slider) {
  let prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  clearRangeOverlayMarks(sliderDOM, prefix);
  const sliderBaseDOM = getCChild(sliderDOM.current, `${prefix}slider-base`);
  const sliderPipDOM = getCChild(sliderDOM.current, `${prefix}slider-pips`);

  if (sliderPipDOM) {
    const lightSliderPipDOM = sliderPipDOM.cloneNode(true);
    lightSliderPipDOM.classList.add(`${prefix}slider-pips-light`);
    sliderBaseDOM.appendChild(lightSliderPipDOM);
    return StepMarkerDrawFunction(lightSliderPipDOM, slider);
  }

  console.error('Failed to generate step markers');
};

exports.generateRangeOverlayMarks = generateRangeOverlayMarks;

const StepMarkerDrawFunction = (overlayPipsDOM, slider) => {
  let animationFrameRef;

  const redrawStepMarkers = (values, rtl) => {
    if (overlayPipsDOM && slider.current) {
      const {
        min,
        max
      } = slider.current.options.range;
      const [startPercent, endPercent] = values.map(value => 100 * (value - min) / (max - min));
      if (animationFrameRef) cancelAnimationFrame(animationFrameRef);
      animationFrameRef = requestAnimationFrame(() => overlayPipsDOM.style.clipPath = `inset(0% ${rtl ? startPercent : 100 - endPercent}% 0% ${rtl ? 100 - endPercent : startPercent}%)`);
    }
  };

  return redrawStepMarkers;
};

exports.StepMarkerDrawFunction = StepMarkerDrawFunction;

const updateAriaLabels = function (labels, sliderDOM) {
  let prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if ((labels && sliderDOM.current) === undefined) return;
  const sliderHandles = [...sliderDOM.current.querySelectorAll(`.${prefix}slider-handle`)];
  sliderHandles.forEach((handle, index) => handle.setAttribute('aria-label', labels[index]));
};

exports.updateAriaLabels = updateAriaLabels;
var _default = StepMarkerDrawFunction;
exports.default = _default;